<template>
<div>
    <ob-modal2 :show.sync="show" width="900px" :backdrop="false" id="scrollable-container">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title">
                   {{ isupdate ? 'Update Student Information (Section 1 & 2)' : 'Complete Student Information (Section 1 & 2)' }}
                </h4>
            </div>
        </template>

        <template slot="modal-body">

            <div class="row rowgap">
                    <div class="col-md-8">
                        <div class="form-group">
                            <div class="form-group">
                                <label>Student Name(Surname/Primary Name, Given Name)</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '1'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '1' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter your full name (Surname/Primary Name, Given Name) exactly as it appears on your SEVIS (Student and Exchange Visitor Information System) issued Form I‐20, “Certificate of Eligibility for Nonimmigrant (F‐1) Student Status – For Academic and Language Students."'/></span>
                                <ob-input v-formi9-name v-model.trim="StudentDetails.Name" placeholder="Enter Student Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.Name.$error }" @input="updateValue('studentName', StudentDetails.Name)"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.required"> Enter name</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty && !$v.StudentDetails.Name.maxLength && $v.StudentDetails.Name.alpha"> Enter 150 characters only</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.Name.$dirty &&  $v.StudentDetails.Name.alpha && !$v.StudentDetails.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Student Email Address</label><span class="validation-star">*</span>
                            <ob-input v-model.trim="StudentDetails.EmailAddress" placeholder="Enter Student Email Address" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.EmailAddress.$error }"></ob-input>
                            <template v-if="$v.StudentDetails.EmailAddress.$dirty">
                                    <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.EmailAddress.required">Enter Student Email</span>
                                    <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.EmailAddress.email"> Enter valid email</span>
                            </template>
                        </div>
                  </div>
            </div>
             <div class="row rowgap">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Name of School Where STEM Degree Was Earned</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '2'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '2' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the name of the school from which you earned the degree upon which the STEM OPT is based.  This may or may not be the same school recommending the STEM OPT if you are using a prior STEM degree."'></span>
                            <ob-input v-model.trim="StudentDetails.NameOfSchoolSTEMOPTDegreeEarned" placeholder="Enter Name of School" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned.$dirty && !$v.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned.required"> Enter name of school</span>
                        </div>
                    </div>
            </div>
             <div class="row rowgap">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Name of School Recommending STEM OPT</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '3'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '3' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the name of your school of most recent enrollment, from which the Designated School Official (DSO) will be recommending STEM OPT."'></span>
                            <ob-input v-model.trim="StudentDetails.NameOfSchoolRecommendingSTEMOPT" placeholder="Enter Name of School" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.NameOfSchoolRecommendingSTEMOPT.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.NameOfSchoolRecommendingSTEMOPT.$dirty && !$v.StudentDetails.NameOfSchoolRecommendingSTEMOPT.required"> Enter name of school</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>SEVIS School Code</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '4'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '4' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the SEVIS School code of the school recommending the STEM OPT (including the 3‐digit suffix). This would be your current school or school of most recent enrollment."'></span>
                            <ob-input v-model.trim="StudentDetails.SEVISSchoolCode" placeholder="Enter SEVIS School Code" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.SEVISSchoolCode.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.SEVISSchoolCode.$dirty && !$v.StudentDetails.SEVISSchoolCode.required"> Enter SEVIS school code</span>
                        </div>
                  </div>
            </div>
            <div class="row rowgap">
                      <div class="col-md-4">
                        <div class="form-group">
                            <label>Designated School Official (DSO) Name</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '10'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '10' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the full name and contact information, including official address, phone, and email, of the DSO who is recommending this STEM OPT and processed this Form I‐983."'></span>
                            <ob-input v-formi9-name v-model.trim="StudentDetails.DSOName" placeholder="Enter DSO Name" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.DSOName.$error }" @input="updateValue('dsoName', StudentDetails.DSOName)"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.DSOName.$dirty && !$v.StudentDetails.DSOName.required"> Enter DSO name</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Designated School Official (DSO) Email</label><span class="validation-star">*</span>
                            <ob-input v-model.trim="StudentDetails.DSOMail" placeholder="Enter DSO Email" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.DSOMail.$error }"></ob-input>
                            <template v-if="$v.StudentDetails.DSOMail.$dirty ">
                                    <span class="ob-vuelidate_error-msg" v-if="!$v.StudentDetails.DSOMail.required"> Enter DSO Email</span>
                                    <span class="ob-vuelidate_error-msg" v-else-if="!$v.StudentDetails.DSOMail.email"> Enter valid email</span>
                            </template>
                        </div>
                    </div>
                     <div class="col-md-4">
                        <div class="form-group">
                            <label>Designated School Official (DSO) Phone</label>
                            <ob-input v-phone-number v-model.trim="StudentDetails.DSOPhone" placeholder="Enter DSO Phone" ></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.DSOPhone.$dirty && !$v.StudentDetails.DSOPhone.maxLength"> Enter valid phone number</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.DSOPhone.$dirty && !$v.StudentDetails.DSOPhone.minLength"> Enter valid phone number</span>
                        </div>
                   </div>
            </div>
            <div class="row rowgap">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Designated School Official (DSO) Address</label>
                            <ob-input v-model.trim="StudentDetails.DSOAddress" placeholder="Enter DSO Address" ></ob-input>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Student SEVIS ID No.</label><span class="validation-star">*</span>
                            <ob-input v-model.trim="StudentDetails.StudentSEVISIdNo" placeholder="Enter Student SEVIS ID No." :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.StudentSEVISIdNo.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.StudentSEVISIdNo.$dirty && !$v.StudentDetails.StudentSEVISIdNo.required"> Enter student SEVIS ID No.</span>
                        </div>
                  </div>
            </div>


                <div class="row rowgap">
                      <div class="col-md-4">
                        <div class="form-group">
                             <label>STEM OPT Requested Period(From)</label><span class="validation-star">*</span>
                           <ob-date-time-picker ref="dateFrom" id="date1" :inputvalue="StudentDetails.STEMOPTRequestedPeriodFrom"  :options="options4" @updated="(v) => this.StudentDetails.STEMOPTRequestedPeriodFrom = v" :dpchange="onFromDateChange"  :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.STEMOPTRequestedPeriodFrom.$error }"></ob-date-time-picker>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.STEMOPTRequestedPeriodFrom.$dirty && !$v.StudentDetails.STEMOPTRequestedPeriodFrom.required"> Enter STEMOPT requested period(from)</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                             <label>STEM OPT Requested Period(To)</label><span class="validation-star">*</span>
                           <ob-date-time-picker ref="dateTo" id="date2" :inputvalue="StudentDetails.STEMOPTRequestedPeriodTo"  :options="options4" @updated="(v) => this.StudentDetails.STEMOPTRequestedPeriodTo = v"  :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.STEMOPTRequestedPeriodTo.$error }"></ob-date-time-picker>
                           <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.STEMOPTRequestedPeriodTo.$dirty && !$v.StudentDetails.STEMOPTRequestedPeriodTo.required"> Enter STEMOPT requested period(to)</span>
                        </div>
                    </div>
                     <div class="col-md-4">
                        <div class="form-group">
                            <label>Employment Authorization Number </label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '5'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '5' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter your “A” number, (which may be found on the Employment Authorization Document)."'></span>
                            <ob-input v-alpha-numeric :maxLength="13" v-model.trim="StudentDetails.EmploymentAuthorizationNumber" placeholder="Enter Employment Authorization" :class="{ 'ob-vuelidate_input-error': ($v.StudentDetails.EmploymentAuthorizationNumber.$error || isShowVal) }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.EmploymentAuthorizationNumber.$dirty && !$v.StudentDetails.EmploymentAuthorizationNumber.required"> Enter Employment Authorization</span>
                            <span class="ob-vuelidate_error-msg" v-if="isShowVal"> Enter valid format</span>
                        </div>
                   </div>
                </div>

                 <div class="row rowgap">
                    <div class="col-md-8">
                        <div class="form-group">
                            <label>Qualifying Major and Classification of Instructional Program (CIP) Code</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '6'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '6' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter your STEM major that qualifies you for the STEM OPT extension, as well as the degree’s (CIP) code.  You can find CIP codes on the National Center for Education Statistics website at: http://nces.ed.gov/ipeds/cipcode/default.aspx?y=55 or the ICE website at http://www.ice.gov/sevis."'></span>
                            <ob-input v-model.trim="StudentDetails.CIPcode" placeholder="Enter CIP Code" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.CIPcode.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.CIPcode.$dirty && !$v.StudentDetails.CIPcode.required">Enter CIP Code</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Level/Type of Qualifying Degree</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '7'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '7' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the academic level upon which you are basing STEM OPT.  (For example, enter Bachelor’s, Master’s, or Ph.D.)"'></span>
                            <ob-input v-model.trim="StudentDetails.QualifyingDegreeType" placeholder="Enter Level/Type of Qualifying Degree" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.QualifyingDegreeType.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.QualifyingDegreeType.$dirty && !$v.StudentDetails.QualifyingDegreeType.required"> Enter Level/Type of Qualifying Degree</span>
                        </div>
                  </div>
                  </div>

                  <div class="row rowgap">
                      <div class="col-md-4">
                        <div class="form-group">
                             <label>Date Awarded(MM/DD/YYYY)</label><span class="validation-star">*</span><span v-on:mouseover="mouseOver = '8'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '8' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='"Enter the date when the degree, upon which STEM OPT will be based, was awarded."'></span>
                            <ob-date-time-picker id="dateawarded" :inputvalue="StudentDetails.DateAwarded" placeholder="select date" :options="options1" @updated="(v) => this.StudentDetails.DateAwarded = v"  v-model.trim="StudentDetails.DateAwarded"  :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.DateAwarded.$error }"></ob-date-time-picker>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.DateAwarded.$dirty && !$v.StudentDetails.DateAwarded.required"> Enter Date Awarded</span>
                        </div>
                       </div>
                     <div class="col-md-4" style=" padding-left: 15px">
                        <div class="form-group">
                            <div class="row">
                             <label>Based on Prior Degree</label><span v-on:mouseover="mouseOver = '9'"
                                    v-on:mouseout="mouseOver= ''" ><img v-bind:src="mouseOver === '9' ? `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_blue.svg` : `${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/information_grey.svg`" class="img_design" v-tooltip='" Check “Yes” if your STEM OPT participation is based on a previously‐obtained STEM degree, and is not the same degree upon which your current post‐completion OPT was granted.  Check “No” if your STEM OPT participation is based on your most recently obtained degree, and that is the degree upon which your current post‐completion OPT is based."'></span>
                            </div>
                            <div class="row">
                                <div class="radio-inline" style="padding-left:0px;">
                                    <ob-radio name="PriorDegree" v-model="StudentDetails.PriorDegree" val="Yes">Yes</ob-radio>
                                </div>

                                <div class="radio-inline">
                                    <ob-radio name="PriorDegree" v-model="StudentDetails.PriorDegree" val="No">No</ob-radio>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <div class="row" v-if="content.SignatureType == 'Electronic'">
            <div class="form-label" style="max-width:50%; padding-left: 15px;">
                <label class="label_title">
                    Signature of Employee
                    <span class="validation-star">*</span>
                </label>
                    <ob-signature-pad v-if="SignatureDetails.EnableSignature" @scrollToTop="scrollToTop" :istrainingpopup="true" @SaveSignature="saveSignature" style="margin-top: 30px; padding-left: 0; text-align: left; width: 0px;"></ob-signature-pad>
                <div v-else class="full-width" style="padding-left:0;display: flex;">
                    <div class="custom-sign-div custom-sign-div_inline_style1">
                        <img :src="SignatureDetails.SignatureURL" :class="{'sign-width': this.SignatureDetails.isDraw, 'add-sign-width': !this.SignatureDetails.isDraw}" alt="Uploaded Signature Url" width="250px" height="100px" style="margin-left: -20px;object-fit: contain;">
                    </div>
                    <div class="custom-sign-div_inline_style2" style="margin-left: 8px;">
                        <img @click="editSignatureMethod(SignatureDetails.image, true)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_edit.svg`" alt="edit" class="edit-sign-icon"><br />
                        <img @click="deleteSiganture(SignatureDetails.image)" :src="`${CDNIMAGESBASEURL}/web/Content/Images/ic_delete.svg`" alt="delete" class="delete-sign-icon">
                    </div>
                    <!-- <div v-if="openEditsignature"> -->
                    <ob-edit-signature-pad @SaveSignatureEdit="SignatureEdit" :editSignature.sync="SignatureDetails.editUpload" :fileName="'StudentSign'" :tabType="SignatureDetails.tabType" :data="SignatureDetails.uploadData" :drawImageProp="SignatureDetails.drawImage" :isDraw="SignatureDetails.isDraw" :metaInformation="SignatureDetails.metaInformation"></ob-edit-signature-pad>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="row">
            <span class="ob-vuelidate_error-msg" style="margin-bottom: 5px;padding-left:12px" v-if="$v.SignatureDetails.Base64Url.$dirty && !$v.SignatureDetails.Base64Url.requiredIf">Please enter signature</span>
        </div>
        <div class="row modal-body">

            <div class="row rowgap" style="padding-left:10px" v-if="isHRManager">
                An Email will be sent to the student with the above information.
            </div>
            <div class="row rowgap" style="padding-left:10px" v-else>
                An Email will be sent to the HR Manager with the above information.
            </div>
        </div>
        </template>

        <template slot="modal-footer" class="modal-footer">
             <ob-button type="secondary" @click="handleCancel">Cancel</ob-button>
             <ob-button type="primary"  @click="onPreview">{{ isupdate ? 'Update' : 'Preview Form' }}</ob-button>
        </template>
    </ob-modal2>

    </div>
</template>
<script>
import namevalidation from "Vue/Core/namevalidation.js"
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
      const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
     const alphawithspace = (value) => {
     var alsp = /^[a-zA-Z\s]*$/i
     return alsp.test(value)
   }
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value !=null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })
import c from 'Vue/Core/constants.js'

    export default {
        props: ["openModal", "content", "isupdate"],
        data(){
            return {
                location: {},
                GeoLocation: '',
                isShowVal: false,
                clonedContent: null,
                show: false,
                StudentObject:'',
                mouseOver:'',
                SignatureDetails:{
                        SignedDate: moment(new Date()).format("MM/DD/YYYY"),
                        SignatureURL: '',
                        EnableSignature : true,
                        IsNewSignature : true,
                        IsAllowEdit: true,
                        uploadData : "",
                        image : "",
                        tabType : "",
                        drawImage : "",
                        editUpload: false,
                        isDraw: false,
                        Base64Url:'',
                        metaInformation: {}
                    },
                StudentDetails:
                {
                    Name:'',
                    EmailAddress:'',
                    NameOfSchoolRecommendingSTEMOPT:'',
                    NameOfSchoolSTEMOPTDegreeEarned:'',
                    SEVISSchoolCode:'',
                    DSOName:'',
                    DSOMail:'',
                    DSOPhone:'',
                    DSOAddress:'',
                    StudentSEVISIdNo:'',
                    STEMOPTRequestedPeriodFrom:'',
                    STEMOPTRequestedPeriodTo:'',
                    EmploymentAuthorizationNumber:'',
                    CIPcode:'',
                    QualifyingDegreeType:'',
                    DateAwarded:'',
                    PriorDegree:'1'
                },
                options4: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY'
                },

                options3: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    widgetPositioning: {
                        horizontal: 'auto',
                        vertical: 'bottom'
                    }
                },
                options1: {
                    format: 'MM/DD/YYYY',
                    dayViewHeaderFormat: 'MM/DD/YYYY',
                    widgetPositioning: {
                        horizontal: "auto",
                        vertical: "bottom"
                    },
                },
            }
        },
        watch: {
            openModal(val) {
                this.show = val;
                if(val) { // On Modal Open
                    this.clonedContent = this.content;
                    if(this.content.SignatureType == 'Electronic') {
                        // this.getLocation()
                    }
                    this.copyFromStore();
                }
            },
            show(val) {
                this.$emit('update:openModal', val)
            },
        },
        computed: {

        },
        created()
        {
           this.show = this.openModal;
           this.resetData();
        },
         validations(){
                    return{
                                "StudentDetails":
                                {
                                    Name:
                                    {
                                            required,
                                            maxLength: maxLength(150),
                                            letterCount
                                    },
                                    EmailAddress:
                                    {
                                         required,
                                         email
                                    },
                                    NameOfSchoolRecommendingSTEMOPT:{
                                           required
                                    },
                                    SEVISSchoolCode:{
                                          required
                                    },
                                    DSOName:{
                                        required
                                    },
                                    DSOMail:{
                                        required,
                                        email
                                    },
                                    DSOPhone:{
                                        maxLength: maxLength(20),
                                        minLength: minLength(10)
                                    },
                                    StudentSEVISIdNo:{
                                        required
                                    },
                                    STEMOPTRequestedPeriodFrom:{
                                        required
                                    },
                                    STEMOPTRequestedPeriodTo:{
                                        required
                                    },
                                    EmploymentAuthorizationNumber:{
                                        required
                                    },
                                    CIPcode:{
                                        required
                                    },
                                    QualifyingDegreeType:{
                                        required
                                    },
                                    DateAwarded:{
                                        required
                                    },
                                    NameOfSchoolSTEMOPTDegreeEarned:{
                                        required
                                    }
                                },
                                SignatureDetails : {
                                    Base64Url: {
                                        requiredIf: requiredIf((a) => {
                                            if(this.content.SignatureType == 'Electronic') {
                                                return true
                                            }else{
                                                return false
                                            }
                                        })
                                    },
                                }
                    }
         },
        methods: {
            scrollToTop(val) {
                if(val) {
                    var a = document.getElementById('scrollable-container')
                    a.scroll({
                        top: 280, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }
            },
            getLocation() {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(position => {
                    this.location = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                        
                    };
                    if(this.location.latitude && this.location.longitude) {
                        const  url = `${c.APIBASEURL}/Google/GeoLocation?latitude=${this.location.latitude}&longitude=${this.location.longitude}`
                        ajax.get(url, {}, res => {
                            if(res.data.Status) {
                            const tempGeoLocation = res.data.GeoLocation
                            this.GeoLocation = `${tempGeoLocation.City}, ${tempGeoLocation.State}, ${tempGeoLocation.Country}`// var location = geoLocationResponse.City + "," + geoLocationResponse.State + "," + geoLocationResponse.Country
                            
                            }
                        })
                    }
                    }, error => {
                    console.error("Error getting user's location:", error);
                    });
                } else {
                    console.error("Geolocation is not supported by this browser.");
                }
            },
            handleCancel() {
            this.show = false
            this.SignatureDetails.SignatureURL=''
            this.SignatureDetails.EnableSignature=true
            this.SignatureDetails.IsNewSignature = false
            this.SignatureDetails.IsAllowEdit=true
            this.SignatureDetails.uploadData=''
            this.SignatureDetails.image=''
            this.SignatureDetails.tabType=''
            this.SignatureDetails.drawImage=''
            this.SignatureDetails.editUpload=false
            this.SignatureDetails.isDraw=false
            this.SignatureDetails.Base64Url=''
            this.SignatureDetails.metaInformation={}
           
        },
            editSignatureMethod(imgUrl, bool){
                // this.resetAttestation()
                if(imgUrl){
                    let specialchar = 'data:image/jpeg;base64';
                    this.SignatureDetails.drawImage = '';
                    let regexPattern = new RegExp(`[${specialchar}]`, 'g');
                    let containsAllChars = specialchar.split('').every(char => imgUrl.match(regexPattern).includes(char));
                    if(containsAllChars) {
                        this.SignatureDetails.drawImage = imgUrl
                    }else {
                        this.SignatureDetails.drawImage = `data:image/jpeg;base64,${imgUrl}`
                    }
                // this.tabType = 'draw'
                this.openEditsignature =  true;
                this.SignatureDetails.editUpload = true
                }
                if(bool) {
                    var a = document.getElementById('scrollable-container')
                    a.scroll({
                        top: 280, 
                        left: 0, 
                        behavior: 'smooth'
                    });
                }
            },
            SignatureEdit(obj){
                let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.EnableSignature = false
                this.SignatureDetails.IsNewSignature = true
                this.SignatureDetails.editUpload = false
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.metaInformation ={}
                // this.IsNewSignature = false
                
                if(obj.type == 'Typed'){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                }
                if(obj.type == 'Uploaded'){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.editUpload = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                }
                if(obj.type == 'Drawn'){
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.data
                    this.SignatureDetails.SignatureURL = obj.data
                    // this.drawImage = obj.drawData
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    this.SignatureDetails.IsNewSignature = true


                }
            },
        saveSignature(obj) {
            let signdata = obj.type == 'Typed' && obj.href ? obj.href.split(',') : obj.type == 'Drawn' && obj.data ? obj.data.split(',') : obj.type =='Uploaded' && obj.image ? obj.image.split(',') : [];
                let base64bitUrl = signdata && signdata.length > 0 ? signdata[signdata.length-1] : ''
                
                // this.resetAttestation()
                this.SignatureDetails.EnableSignature = true
                this.SignatureDetails.uploadData = ""
                this.SignatureDetails.image = ""
                this.SignatureDetails.tabType = ""
                this.SignatureDetails.drawImage = ""
                this.SignatureDetails.IsNewSignature = false
                
                
                if(obj.type == 'Typed'){
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.uploadData = obj.href
                    this.SignatureDetails.image = obj.href
                    this.SignatureDetails.SignatureURL = obj.href
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = false
                    this.SignatureDetails.metaInformation = obj.metaInformation
                    // this.IsNewSignature = true
                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Uploaded'){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.image
                    this.SignatureDetails.SignatureURL = obj.image
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    // this.Section1.SignatureDetails.editUpload =true
                }
                if(obj.type == 'Drawn'){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = false
                    this.SignatureDetails.uploadData = obj.data
                    this.SignatureDetails.image = obj.data
                    this.SignatureDetails.SignatureURL = obj.data

                    // this.drawImage = obj.drawData
                    this.SignatureDetails.tabType = obj.type
                    this.SignatureDetails.Base64Url = base64bitUrl
                    this.SignatureDetails.isDraw = true
                    // this.IsNewSignature = true
                    // this.Section1.SignatureDetails.editUpload =true
                }
        },
        deleteSiganture(imgUrl){
                // this.resetAttestation()
                if(imgUrl){
                    this.SignatureDetails.IsNewSignature = true
                    this.SignatureDetails.EnableSignature = true
                    this.SignatureDetails.image = ''
                    this.SignatureDetails.Base64Url = ''
                    // this.$store.commit('updateWorkAuthorizationValue', { field: 'signature', value: '' })
                }
            },
            updateValue(modelName, value){
              let val = namevalidation.getValidName(value);
              if(modelName == "studentName")
                this.StudentDetails.Name = val
              else
                this.StudentDetails.DSOName = val
            },  
            resetData() {
                // Reset data
                this.StudentDetails = {
                    Name:'',
                    EmailAddress:'',
                    NameOfSchoolRecommendingSTEMOPT:'',
                    NameOfSchoolSTEMOPTDegreeEarned:'',
                    SEVISSchoolCode:'',
                     DSOName:'',
                    DSOMail:'',
                    DSOPhone:'',
                    DSOAddress:'',
                    StudentSEVISIdNo:'',
                    STEMOPTRequestedPeriodFrom:'',
                    STEMOPTRequestedPeriodTo:'',
                    EmploymentAuthorizationNumber:'',
                    CIPcode:'',
                    QualifyingDegreeType:'',
                    DateAwarded:'',
                    PriorDegree:'1'
                };

                // Reset Validation
                this.$v.StudentDetails.$reset();
                this.$v.SignatureDetails.$reset();

            },
            copyFromStore() {
                // reset data
                this.resetData();

              this.StudentDetails.Name = this.clonedContent.Employee.Name;
              this.StudentDetails.EmailAddress = this.clonedContent.Employee.Email;
              this.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned = this.clonedContent.Employee.DegreeEarnedSchoolName;
              this.StudentDetails.NameOfSchoolRecommendingSTEMOPT = this.clonedContent.Employee.RecommendingSchoolName;
              this.StudentDetails.SEVISSchoolCode = this.clonedContent.Employee.RecommendingSchoolCode;
              this.StudentDetails.DSOName = this.clonedContent.Employee.DSO;
              this.StudentDetails.DSOMail = this.clonedContent.Employee.DSOMail;
              this.StudentDetails.DSOPhone = this.clonedContent.Employee.DSOPhone;
              this.StudentDetails.DSOAddress = this.clonedContent.Employee.DSOAddress;
              this.StudentDetails.StudentSEVISIdNo = this.clonedContent.Employee.SEVISID;
              this.StudentDetails.STEMOPTRequestedPeriodFrom = this.clonedContent.Employee.RequestedFrom;
              this.StudentDetails.STEMOPTRequestedPeriodTo = this.clonedContent.Employee.RequestedTo;
              this.StudentDetails.EmploymentAuthorizationNumber = this.clonedContent.Employee.EmploymentAuthorizationNumber;
              this.StudentDetails.CIPcode = this.clonedContent.Employee.CIPCode;
              this.StudentDetails.QualifyingDegreeType = this.clonedContent.Employee.QualifyingDegreeType;
              this.StudentDetails.DateAwarded = this.clonedContent.Employee.DateAwarded;
              this.StudentDetails.PriorDegree = this.clonedContent.Employee.PriorDegree;
              this.SignatureDetails.SignatureURL = this.clonedContent.Employee.SignatureURL
              this.SignatureDetails.Base64Url = this.clonedContent.Employee.Base64EncodedSignature
              this.SignatureDetails.EnableSignature = this.clonedContent.Employee.SignatureURL && this.clonedContent.Employee.SignatureURL != '' ? false : true,
              this.SignatureDetails.tabType = this.clonedContent.Employee.SigningType
              this.SignatureDetails.image = this.clonedContent.Employee.Base64EncodedSignature
            },
            copyToStore() {
                this.clonedContent.Employee.Name = this.StudentDetails.Name;
                this.clonedContent.Employee.Email = this.StudentDetails.EmailAddress;
                this.clonedContent.Employee.DegreeEarnedSchoolName = this.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned;
                this.clonedContent.Employee.RecommendingSchoolName = this.StudentDetails.NameOfSchoolRecommendingSTEMOPT;
                this.clonedContent.Employee.RecommendingSchoolCode = this.StudentDetails.SEVISSchoolCode;
                this.clonedContent.Employee.DSO = this.StudentDetails.DSOName;
                this.clonedContent.Employee.DSOMail = this.StudentDetails.DSOMail;
                this.clonedContent.Employee.DSOPhone = this.StudentDetails.DSOPhone;
                this.clonedContent.Employee.DSOAddress = this.StudentDetails.DSOAddress;
                this.clonedContent.Employee.SEVISID = this.StudentDetails.StudentSEVISIdNo;
                this.clonedContent.Employee.RequestedFrom = this.StudentDetails.STEMOPTRequestedPeriodFrom;
                this.clonedContent.Employee.RequestedTo = this.StudentDetails.STEMOPTRequestedPeriodTo;
                this.clonedContent.Employee.EmploymentAuthorizationNumber = this.StudentDetails.EmploymentAuthorizationNumber;
                this.clonedContent.Employee.CIPCode = this.StudentDetails.CIPcode;
                this.clonedContent.Employee.QualifyingDegreeType = this.StudentDetails.QualifyingDegreeType;
                this.clonedContent.Employee.DateAwarded = this.StudentDetails.DateAwarded;
                this.clonedContent.Employee.PriorDegree = this.StudentDetails.PriorDegree;
                this.clonedContent.Employee.PriorDegree = this.StudentDetails.PriorDegree;
                this.clonedContent.Employee.PriorDegree = this.StudentDetails.PriorDegree;
                this.clonedContent.Employee.PriorDegree = this.StudentDetails.PriorDegree;
                this.clonedContent.Employee.SignatureURL = this.SignatureDetails.image;
                this.clonedContent.Employee.Base64EncodedSignature = this.SignatureDetails.Base64Url
                this.clonedContent.Employee.SigningType = this.SignatureDetails.tabType

                
            // this.clonedContent.Employer.SignatureURL = this.SignatureDetails.SignatureURL
            // this.clonedContent.Employer.SignatureURL = this.SignatureDetails.EnableSignature


                this.clonedContent.Employee.SectionStatus = "Completed";

                // Insert into modified log
                this.$parent.$parent.insertModifiedLogToStore('Student');
            },
           onFromDateChange(e) {
                    this.$refs.dateTo.data.minDate(e.date)
           },
           onPreview()
           {
              this.$v.StudentDetails.$touch();
              this.$v.SignatureDetails.$touch();


              if(this.$v.StudentDetails.$invalid  == false && this.isShowVal == false && !this.$v.SignatureDetails.$invalid)
              {
                 let empInfo ={
                    Name:this.StudentDetails.Name,
                    Email:this.StudentDetails.EmailAddress,
                    RecommendingSchoolName:this.StudentDetails.NameOfSchoolRecommendingSTEMOPT,
                    DegreeEarnedSchoolName:this.StudentDetails.NameOfSchoolSTEMOPTDegreeEarned,
                    RecommendingSchoolCode:this.StudentDetails.SEVISSchoolCode,
                    DSO:this.StudentDetails.DSOName,
                    DSOMail:this.StudentDetails.DSOMail,
                    DSOPhone:this.StudentDetails.DSOPhone,
                    DSOAddress:this.StudentDetails.DSOAddress,
                    SEVISID:this.StudentDetails.StudentSEVISIdNo,
                    requestedFrom:this.StudentDetails.STEMOPTRequestedPeriodFrom,
                    requestedTo:this.StudentDetails.STEMOPTRequestedPeriodTo,
                    EmploymentAuthorizationNumber:this.StudentDetails.EmploymentAuthorizationNumber,
                    CIPCode: this.StudentDetails.CIPcode,
                    QualifyingDegreeType: this.StudentDetails.QualifyingDegreeType,
                    DateAwarded:this.StudentDetails.DateAwarded,
                    PriorDegree:this.StudentDetails.PriorDegree,
                    SignedDate: this.SignatureDetails.SignedDate,
                    Base64EncodedSignature: this.SignatureDetails.Base64Url,
                    SigningType:this.SignatureDetails.tabType
                  }
                this.StudentObject={
                    Employee:empInfo,
                    // GeoLocation: this.SignatureDetails.IsNewSignature ? this.GeoLocation : null,
                    GeoLocation: this.SignatureDetails.IsNewSignature ? 'SignatureSigned' : null,
                    UserAgent:navigator.userAgent

                }
                 if(this.isupdate) {
                      this.updateStudentDetails();
                  } else {
                      this.$loading({'loadingText': 'Previewing Student Information...'});
                      this.$parent.previewDocument("Student", this.StudentObject)
                  }
              }
              else{
                  this.$loading({}).close()
              }
           },
          updateStudentDetails()
          {
               if(this.isupdate) {
                    this.$loading({'loadingText': 'Updating Student Information...'});
                } else {
                    this.$loading({'loadingText': 'Initiating Student Information...'});
                }
              ajax.put(`/I983/${this.content.Id}/UpdateStudentDetails`, this.StudentObject, (res) => {
                  if(res.data.State == true){
                    if(this.isupdate) {
                        this.$message({
                            type: 'success',
                            message: 'Student Information updated successfully'
                        });
                    } else {
                        this.$message({
                            type: 'success',
                            message: 'Student Information initiated successfully'
                        });
                    }
                    this.$loading({}).close();
                    this.show = false;

                    this.copyToStore();
                  }else if(res.data.State == false){
                    this.$loading({}).close();
                    this.show = false;
                    this.ESSEnableDisable(res)
                    this.$message({
                        type: 'error',
                        message: res.data.Message
                    });
                  }
              });
              },
              patternMatch: function() {
                       // let regex = /^(A)([0-9]{9})$/gm
                        let regex = "^[a-zA-Z]{3}\\d{10}$"
                        let re = new RegExp(regex, 'g')
                        let res = re.test(this.StudentDetails.EmploymentAuthorizationNumber)
                        if (res == false && this.StudentDetails.EmploymentAuthorizationNumber !='') {
                            this.isShowVal = true
                        } else {
                            this.isShowVal = false
                        }
                },
        }
    }
</script>
<style lang="scss" scoped>
   .title-content
   {
       color: #4a90e2;
       font-size: 14px;
   }
   .rowgap
   {
       margin-top: 10px;
   }
   .validation-star{
            color: #F31D1D;
    }
    .radio-inline
    {
        padding-left: 0px
    }
    label{

         color :#a4abb9
    }
    .preview-details {
		padding: 10px 0;
	}
     .img_design{
        width: 15px;
        border-radius: 25%;
        margin-left: 6px;
    }
    .edit-sign-icon {
        height: 35px;
        width: 35px;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .delete-sign-icon {
        height: 35px;
        width: 35px; 
        margin-bottom: -65px;
        cursor: pointer;
    }
    .custom-sign-div {
        flex: 1 1 auto;
        min-height: 1px;
        /* padding: 1.5rem; */
        background: #FCFCFF;
        text-align: center;
        border: 1px solid rgba(219,219,232,0.50);
        width: 650px;
        height:139px !important;
        padding: 20px 15px;
    }
    .custom-sign-div_inline_style1{
        display:inline-block;
        height:100px;
        width:49%;
        float:left; 
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateStudentInformation.vue